import {
  ExerciseCategoryId,
  ExerciseCategoryName,
  IExerciseCategoryName,
} from '../views/components/Exercise/exercise.interface';

const categories = {
  [ExerciseCategoryName.THEORY]: 1,
  [ExerciseCategoryName.PRACTICE]: 2,
};

function getExerciseCategoryId(
  categoryName: IExerciseCategoryName,
): typeof ExerciseCategoryId.THEORY | typeof ExerciseCategoryId.PRACTICE {
  return categories[categoryName];
}

export { getExerciseCategoryId };
